/**
 * Safe localStorage wrapper — prevents TypeError when localStorage is null
 * (e.g., privacy mode browsers, SSR, restricted environments).
 *
 * Usage: import { safeStorage } from '../utils/safeStorage';
 *        safeStorage.getItem('key');
 *        safeStorage.setItem('key', 'value');
 *        safeStorage.removeItem('key');
 */

function isAvailable() {
  try {
    return typeof window !== 'undefined' && window.localStorage !== null && window.localStorage !== undefined;
  } catch {
    return false;
  }
}

export const safeStorage = {
  getItem(key) {
    try {
      return isAvailable() ? localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      if (isAvailable()) localStorage.setItem(key, value);
    } catch {}
  },
  removeItem(key) {
    try {
      if (isAvailable()) localStorage.removeItem(key);
    } catch {}
  },
  clear() {
    try {
      if (isAvailable()) localStorage.clear();
    } catch {}
  }
};

export default safeStorage;
